import _ from 'lodash'
import { fileUrl } from 'src/utils/lib'
import { startLoading, stopLoading } from '../../../redux/slices/loading'
import { getRegistrationDetail } from '../../../services/class/registration'
import { setRegistrationData } from '../../../redux/slices/class/registration'

import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { StyledLayoutBox } from './Styled'
import axios from 'axios'
import { eCertificationDownload } from 'src/utils/apiPath'

export const LINE_OPTION = {
  MULTILINE: 'multiline',
}

export const LayoutPreview = ({ version }) => {

  return (
    <StyledLayoutBox
      url={fileUrl(version.eCertificationBackground?.imageKey)}
    >
      {_.map(version.layout.layout, (l, key) => {
        if (l.type === LINE_OPTION.MULTILINE) {
          const courseName = l?.courseName
          let style = { display: 'flex' }
          if(courseName) {
            style.marginTop = '50px'
          }
          return (
            <div key={`layout_box_${key}`} style={style}>
              {_.map(l.layout, (li, n) => {
                return (
                  <Typography
                    key={`layout_box_n_${n}`}
                    sx={{ ...l.style, ...li.style }}
                  >
                    {!_.isEmpty(li.text) ? li.text : ' '}
                  </Typography>
                )
              })}
            </div>
          )
        }
        return (
          <Box key={`layout_list_${key}-${version.id}`} sx={l.style}>
            {l.text}
          </Box>
        )
      })}
    </StyledLayoutBox>
  )
}

export const onDownload = (uuid) => async (dispatch) => {
  dispatch(startLoading())
  await axios
    .get(`${eCertificationDownload}/${uuid}`, { responseType: 'blob' })
    .then((data) => {
      const url = window.URL.createObjectURL(new Blob([data.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `e-certification.pdf`)
      document.body.appendChild(link)
      link.click()
    })
    .catch(() => dispatch(stopLoading()))
    .finally(() => dispatch(stopLoading()))
}

export const fetchDataRegistration = (body) => async (dispatch) => {
  dispatch(startLoading())
  const result = await dispatch(getRegistrationDetail(body))
  dispatch(setRegistrationData(_.get(result, 'payload.data', {})))
  dispatch(stopLoading())
}

export const handleReviewAnswer = (data, trainingPlanUuid) => {
  const courseTestAndEvaluateDataUuid = _.get(
    data,
    'courseTestAndEvaluateDataUuid',
    ''
  )
  const eTestLink = `${window.__env__.REACT_APP_APP_URL}/e-testing/on-review/${courseTestAndEvaluateDataUuid}?class=${trainingPlanUuid}`
  window.open(eTestLink, '_blank')
}
